class ServiceUnavailable extends Error {
    constructor(message = 'Service Unavailable. The server is currently unable to handle the request due to a temporary overloading or maintenance of the server.') {
      super(message)
      this.name = this.constructor.name
      this.status = 503
      Error.captureStackTrace(this, this.constructor)
    }
}

module.exports = ServiceUnavailable
